import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { logError, modal, notification } from 'redux/modules/app'
import {
  metrics as metricsApi
} from 'redux/modules/api'

function decorator() {
  return ComposedComponent => {
    @connect(({ api }) => ({ search: api.search }), {
      ...metricsApi,
      notification,
      modal,
      logError,
    })
    @withRouter
    class Metrics extends Component {
      static propTypes = {
        recalculateOrganizationMetrics: PropTypes.func,
        notification: PropTypes.func,
        logError: PropTypes.func
      }

      handleRecalculateOrganizationMetrics = (data = {}) => {
        this.props.recalculateOrganizationMetrics(data)
            .then(() => {
              this.props.modal(null)
            })
            .catch(this.handleError)

      }

      handleError = err => {
        console.log('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      render() {
        return (
            <ComposedComponent
                {...this.props}
                recalculateOrganizationMetrics={this.handleRecalculateOrganizationMetrics}
            />
        )
      }
    }
    return Metrics
  }
}

export default decorator
